import { ChevronDown } from 'lucide-react';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  name?: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  placeholder?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLSelectElement>) => void;
  testId?: string;
}

export function SelectInput({
  label,
  value,
  onChange,
  options,
  name,
  required = false,
  error,
  helperText,
  placeholder = 'Select an option',
  onKeyDown,
  testId,
}: SelectInputProps) {
  return (
    <div className="flex flex-col">
      <label className="label-compact block">
        {label}
        {required && <span className="text-red-600 ml-1">*</span>}
      </label>
      <div className="relative">
        <select
          value={value}
          name={name}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
          data-testid={testId}
          className={`input-compact w-full pr-8 border rounded-md appearance-none transition-colors ${
            error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'
          }`}
        >
          <option value="">{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-2 top-2 h-4 w-4 text-gray-400 pointer-events-none" />
      </div>
      {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
      {helperText && !error && (
        <p className="text-xs text-gray-500 mt-1">{helperText}</p>
      )}
    </div>
  );
}
